export const ageValidator = (inputValue: string, minAge: number) => {
  const inputDate = new Date(inputValue);
  const currentDate = new Date();
  const thirteenYearsAgo = new Date(currentDate.setFullYear(currentDate.getFullYear() - minAge));
  if (inputDate > thirteenYearsAgo) {
    return false;
  }
  return true;
};
